import { render, staticRenderFns } from "./small.vue?vue&type=template&id=5d275960&scoped=true"
import script from "./small.vue?vue&type=script&lang=js"
export * from "./small.vue?vue&type=script&lang=js"
import style0 from "./small.vue?vue&type=style&index=0&id=5d275960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d275960",
  null
  
)

export default component.exports